import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M4 16.42V7.58c0-1.566 1.716-2.524 3.048-1.704l7.184 4.42a2 2 0 0 1 0 3.407l-7.184 4.421C5.716 18.944 4 17.985 4 16.421M16 7a2 2 0 1 1 4 0v10a2 2 0 1 1-4 0z"
    }
  )
);
var SvgSkipNextFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var SkipNextFilled_default = SvgSkipNextFilled;

export { SkipNextFilled_default as default };
